// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "header__text-3Cs3f";
var _3 = "tabs__segment-2T01U";
var _4 = "tabs__header-18_Z7";
var _5 = "airport-1zu7v";
var _6 = "service-PU7k3";
var _7 = "header__textIcon-dGwuc";
var _8 = "time-1kb4Z";
var _9 = "fareName-33e2C";
var _a = "header__title-dofRB";
var _b = "tabs__value-2TYki";
var _c = "tabs__tab-16E3m";
var _d = "tabs__tab__header-26PuL";
var _e = "tabs__selectedTab-1IX6E";
export { _1 as "__esModule", _2 as "header__text", _3 as "tabs__segment", _4 as "tabs__header", _5 as "airport", _6 as "service", _7 as "header__textIcon", _8 as "time", _9 as "fareName", _a as "header__title", _b as "tabs__value", _c as "tabs__tab", _d as "tabs__tab__header", _e as "tabs__selectedTab" }
export default { "__esModule": _1, "header__text": _2, "tabs__segment": _3, "tabs__header": _4, "airport": _5, "service": _6, "header__textIcon": _7, "time": _8, "fareName": _9, "header__title": _a, "tabs__value": _b, "tabs__tab": _c, "tabs__tab__header": _d, "tabs__selectedTab": _e }
